import {PortableText, PortableTextProps} from '@portabletext/react'
import useImageBuilder from '~/hooks/useImageBuilder'

const LegalText = (props: PortableTextProps) => {
    const builder = useImageBuilder()

    return (
        <PortableText
            {...props}
            components={{
                types: {
                    image: (props) => (
                        <img
                            className="max-w-80 select-none"
                            alt=""
                            src={builder.image(props.value).fit('max').auto('format').url()}
                        />
                    ),
                },
                block: {
                    normal: ({children}) => <p className="my-2">{children}</p>,
                    h2: ({children}) => (
                        <h2 className="text-2xl font-bold mb-2 mt-6">{children}</h2>
                    ),
                    h3: ({children}) => <h3 className="text-xl font-bold mb-2 mt-6">{children}</h3>,
                    h4: ({children}) => <h4 className="text-lg font-bold mb-2 mt-6">{children}</h4>,
                },
                list: {
                    bullet: ({children}) => (
                        <ul className="list-disc space-y-1 my-1 ml-4">{children}</ul>
                    ),
                    number: ({children}) => (
                        <ol className="list-decimal space-y-1 my-1 ml-4">{children}</ol>
                    ),
                },
                marks: {
                    link: ({value, children}) => {
                        const target = (value?.href || '').startsWith('http') ? '_blank' : undefined
                        return (
                            <a
                                className="underline"
                                href={value?.href}
                                target={target}
                                rel={target === '_blank' ? 'noindex nofollow' : undefined}
                            >
                                {children}
                            </a>
                        )
                    },
                },
            }}
        />
    )
}

export default LegalText
